<dialog
  #dialog
  qai-dialog
  [heading]="titleKey() | transloco"
  [description]="descriptionKey() | transloco"
  [showClose]="false"
>
  <div class="exit-buttons">
    <button qai-button size="medium" kind="tertiary" (click)="onResume()">
      {{ 'learningPathway.ASSESSMENT_EXIT_MODAL_RESUME' | transloco }}
    </button>
    <button qai-button size="medium" kind="primary" (click)="onConfirmExit()">
      {{ 'learningPathway.ASSESSMENT_EXIT_MODAL_PROCEED' | transloco }}
    </button>
  </div>
</dialog>
